import { CSVLink } from 'react-csv';
import { Image, Stack, StackItem } from "@fluentui/react";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { useState, useEffect, useContext, useRef, ChangeEvent, FormEvent, SetStateAction } from "react";
import { Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, Input, Tooltip, Badge, Body2, Body1Stronger, Spinner } from "@fluentui/react-components";
import { Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, Dismiss16Regular, AddSquare20Regular, ArrowDownload20Regular, ArrowUpload20Regular, Open20Regular, Delete20Regular, Settings20Regular, Info16Filled, Copy20Regular } from "@fluentui/react-icons";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { MultiselectWithTags } from '../../../components/dropdown/multiselect.component';
import { DatepickerComponent } from '../../../components/picker/datepicker.component';
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { SkeletonDataTable } from '../../../components/skeleton/skeletonDataTable';
import { Pagination } from "../../../components/pagination/pagination.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import { SearchBar } from '../../../components/searchbar/searchbar.component';
import { AutomationPages } from '../../../components/side_menu/InlineSidenav';
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { ToastComponent } from '../../../components/toast/toast.component';
import { Resize } from '../../../components/textarea/textarea.component';
import { InfoBar } from '../../../components/infoBar/infoBar.component';
import { Inputs } from '../../../components/textarea/input.component';
import FullScreenButton from '../../../components/fullscreen/fullScreen.component';
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import DialogBox from '../../../components/dialog/dialog.component';
import * as XLSX from 'xlsx'
import client from '../../../api/apollo';
import validator from '@rjsf/validator-ajv8';
import Alert_func from '../../../api/automation/alert_func';
import { Form } from "@rjsf/fluent-ui";
import { GlobalContext } from '../../../hooks/globalContext';
import { addAlertQuery } from '../../../graphql/alert_queries';
import { usePermissionStore } from "../../../Store/permissionStore";
import { convertToLocalTimezone, convertUTCToReadableFormat, convertToExcelFormat } from "../../../utility/utils";
import { primaryIcon, secondaryIcon, buttonContent, DynamicBoxingCSS, SubSectionResponsive, parentHome, wraperStyle, timezoneInfo, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";

interface ButtonElement extends HTMLButtonElement {
    click: () => void;
};

interface iFetch {
    (value: SetStateAction<string[]>): void;
};

interface iID {
    id: any;
};

interface iName {
    name: any;
}

interface iInput {
    target: {
        name?: any;
        value?: any;
    };
};

interface iCreatedBy {
    createdBy: any;
};

interface iAlertTable {
    name: any;
    id: any;
    status: any;
    createdBy: any;
    createdon: any;
    createdOn: any;
    lastModified: any;
};

export const AutomateAlert = () => {
    // NOTE THAT THIS IS A HARDCODED DATA, AND IS NOT AN ACTUAL DATA FROM DATABASE, HAVE TO MAKE IT DYNAMIC IS PRIORITIZED
    const [final_data, set_final_data] = useState(null);
    const [rowID, setRowID]: any = useState(null);
    const [tracker, setTracker] = useState(false);
    const [isToast, setIsToast] = useState(false);
    const [isfilter, setIsFilter] = useState(false);
    const [isRefresh, setIsRefresh] = useState(false);
    const [overlayOpen, setOverlayOpen] = useState(false);
    const [deleteAlert, setIsDeleteAlert] = useState(false);
    const [refreshToast, setRefreshToast] = useState(false);
    const [filterMenuOpen, setFilterMenuOpen] = useState(false);
    const [overlayOpenNew, setOverlayOpenNew] = useState(false);
    const [toastAlertEdit, setToastAlertEdit] = useState(false);
    const [editBtnClicked, setEditBtnClicked] = useState(false);
    const [saveBtnClicked, setSaveBtnClicked] = useState(false);
    const [toastAlertError, setToastAlertError] = useState(false);
    const [exportBtnClicked, setExportBtnClicked] = useState(false);
    const [toastAlertCreate, setToastAlertCreate] = useState(false);
    const [toastAlertDelete, setToastAlertDelete] = useState(false);
    const [isDuplicateDisabled, setIsDuplicateDisabled] = useState(true);
    const [isdeletedisabled, setDeleteDisabled] = useState(true);
    const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
    const [isResetDisabled, setResetDisabled] = useState(true);
    const [loading, setLoading] = useState(true);
    const [tableData, setTableData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [exportDetails, setExportDetails] = useState([]);
    const [tableColumnsData, setTableColumnsData] = useState([]);
    const [filterColumnsData, setFilterColumnsData] = useState([]);
    const [troubleshooterList, setTroubleshooterList] = useState([]);
    const [selectedTroubleshooterList, setSelectedTroubleshooterList] = useState([]);
    const [uiData, setUiData] = useState({});
    const [jsonData, setJsonData] = useState({});
    const [formDataAlert, setFormDataAlert]: any = useState({});
    const [searchVal, setSearchVal] = useState("");
    const [overlayName, setOverlayName] = useState('');
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [importedDataInserted, setImportedDataInserted] = useState<any>(false);
    const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
    const [filterArray, setFilterArray] = useState<string[]>([]);
    const [csvAlertList, setCsvAlertList] = useState<any>([]);
    const [isCreatedBy, setCreatedBy] = useState<any[]>([]);
    const [overLayData, setOverLayData] = useState<any>({});
    const [selectedFile, setSelectedFile] = useState<any>();
    const [dropDownValue1, setDropDownValue1] = useState<any>();
    const [dropDownValue2, setDropDownValue2] = useState<any>();
    const [overLayDataNew, setOverLayDataNew] = useState<any>({});
    const [criteriaList, setCriteriaList] = useState(["No Options"]);
    const [criteriaList2, setCriteriaList2] = useState(["No Options"]);
    const [criteriaList3, setCriteriaList3] = useState(["No Options"]);
    const [formData, setFormData]: any = useState({ name: '', description: '' });
    const [spinnerLoad, setSpinnerLoad] = useState(true);
    const [userActivityData, setUserActivityData] = useState({});
    const [duplicateAutomation, setDuplicateAutomation] = useState(false);
    const [editUserDetails, setEditUserDetails] = useState(false);
    const [saveUserDetails, setSaveUserDetails] = useState(false);
    const [importBtnClicked, setImportBtnClicked] = useState(false);
    const [dropdownData, setDropdownData] = useState<any | null>(null);
    const [readOnly, setReadOnly] = useState<boolean>(false)
    const [dropDownValue3, setDropDownValue3] = useState<any>();
    const [isDeleteRole, setIsDeleteRole] = useState(false);

    const { permissions } = usePermissionStore();
    const alertPermit = permissions.includes("all") || permissions.includes("alert_Fullaccess");
    const exportPermit = alertPermit || permissions.includes("alert_ReadandExport");
    const importPermit = alertPermit || permissions.includes("alert_ReadandExport");

    console.log("spinnerLoad",spinnerLoad)
    const contextValue = useContext(GlobalContext);
    const {
        tenantName, userSessionDetails, selectedRowIdInTable, tableColumnsData: contextTable,
        setManageViewDropDownData, setManageViewPageDetails, setSelectedRowIdInTable, setSelectedRowIdInSubTable
    } = contextValue;
    const { Alerts: contextAlerts } = contextValue?.tableColumnsData?.Automation || {};

    const handle = useFullScreenHandle();
    const buttonref = useRef(null);
    const formRef = useRef(null);

    useEffect(() => {
        const createdByOptions = uniqueCreatedBy.map((item) => ({ key: item, label: <Caption1> {item} </Caption1> }));
        setCreatedBy(createdByOptions);
        console.log("Checking created by options: ", createdByOptions);
    }, [uniqueCreatedBy]);

    useEffect(() => {
        if (filterArray.length > 0) { setResetDisabled(false) };
    }, [filterArray]);

    var userTimeZone = userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');
    // useEffect(() => { if (filterArray.length > 0) { setResetDisabled(false) } }, [filterArray])

    const handleOutsideButton = () => buttonref?.current?.click();

    const handleFilterArray = () => {
        // if(dropDownValue1 !== undefined && dropDownValue1 !== '' && dropDownValue2 !== undefined && dropDownValue2 !== '') {
        const result = `${dropDownValue1} : ${dropDownValue2}`;
        setFilterArray([...filterArray, result]);
        setIsFilter(true);
        setDropDownValue1('');
        setDropDownValue2('');
        setLoading(true);
        // }
    };

    const handleCloseFilter = (index: number) => {
        console.log("Clicked...");
        setFilterArray(filterArray.filter((x, itemIndex) => itemIndex !== index)); // updatedArray
        setDropDownValue1('');
        setDropDownValue2('');
    };

    useEffect(() => {
        if (filterArray.length > 0) return setResetDisabled(false)
        else return setResetDisabled(true);
    }, [filterArray]);

    useEffect(() => {
        if (overlayOpen) {
            const element = document.getElementById("fluent-default-layer-host");
            if (element) { element.style.zIndex = '9999999' };
        };
        const button: ButtonElement = document.querySelector('button.ms-Button--commandBar');
        setTimeout(() => { button?.click() }, 1500);
    }, [overlayOpen]);

    const inputChange = (e: iInput) => {
        const { value } = e.target;
        const alphabet = /^[A-Za-z ]*$/;
        const alphanumeric = /^[A-Za-z0-9_ -]*$/;
        const numberic = /^[0-9]*$/;
        let name = e.target.name;
        if (name === 'filter') {
            const primary = dropDownValue1 === "Name" || dropDownValue1 === "Created By";
            const secondary = dropDownValue1 === "Status";
            if ((primary && alphanumeric.test(value)) || (secondary && alphabet.test(value))) { setDropDownValue2(value) };
        };
    };

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => e.preventDefault();

    const handleSave = () => {
        (overlayName === 'edit') ? setEditBtnClicked(true) : setSaveBtnClicked(true);
        setOverlayOpen(false);
    };

    const handleEditData = async (data: any) => {
        const { formDataEdit, solutions, name: nameD, description: descriptionD } = data || {};
        const alertDetails = JSON.parse(formDataEdit);
        const troubleshooterSolutions = JSON.parse(solutions);

        console.log('Checking alertDetails: ' + JSON.stringify(data));
        console.log('Troubleshooter solutions: ' + troubleshooterSolutions !== 'null');

        setFormDataAlert(alertDetails);
        (troubleshooterSolutions) && setSelectedTroubleshooterList(troubleshooterSolutions);

        const fetchCriteria = async (dartName: any, setCriteriaList: iFetch) => {
            if (dartName) { await fetchCriteriaList(dartName, setCriteriaList) };
        };

        const { selectDart, selectDart2, selectDart3 } = formDataEdit || {};
        await Promise.all([
            fetchCriteria(selectDart, setCriteriaList),
            fetchCriteria(selectDart2, setCriteriaList2),
            fetchCriteria(selectDart3, setCriteriaList3)
        ]);

        setFormData({ name: nameD, description: descriptionD })
        // setCurrentSelectedUserFormDetails(userDetails);
        // console.log('User details: ', userDetails.role);
    };

    const handleOnCickEdit = (val: iID) => {
        setRowID(val.id);
        setOverlayName('edit');
        setOverlayOpen(true);
        setSpinnerLoad(true);
        // setReadOnly(true);
    };

    function extractNumberFromString(inputString: String) {
        const match = inputString?.match(/\d+/);
        return match ? match[0] : null;
    };

    const fetchCriteriaList = async (dartName: String, CriteriaDropDownList: iFetch) => {
        console.log('Dart Name: ', dartName);
        const extractedNumber = extractNumberFromString(dartName);
        const pinotLink = "https://pinot-dev.nanoheal.work/tables/t1_d312_dart" + extractedNumber + "_v1/schema"; // Output: Found number: 286
        // const dart_Name = formDataAlert?.selectDart;
        // const dartnoA = extractNumberAfterDart(dart_Name?.trim())
        // const dartnoB = "t1_d312_dart" + extractNumberAfterDart(dart_Name) + " _v1" + "t1_d312_dart63_v1";
        // const dartNo = `${dartnoA}_${dartnoB}`;
        try {
            await fetch(pinotLink)
                .then((response) => response.json())
                .then((data) => {
                    const criteriaList = data?.metricFieldSpecs.map((criteria: iName) => criteria?.name);
                    if (criteriaList.length > 0) return CriteriaDropDownList(criteriaList);
                    else return CriteriaDropDownList(["No Options"]);
                });
        } catch (error) {
            console.log("Error fetching data from the Pinot API for Criteria: ", error);
        }
    };

    // useEffect(() => {
    //   formDataAlert?.selectDart && fetchCriteriaList(formDataAlert?.selectDart, setCriteriaList);
    // }, [formDataAlert?.selectDart]);
    // useEffect(() => {
    //   formDataAlert?.selectDart2 && fetchCriteriaList(formDataAlert?.selectDart2, setCriteriaList2);
    // }, [formDataAlert?.selectDart2]);
    // useEffect(() => {
    //   formDataAlert?.selectDart3 && fetchCriteriaList(formDataAlert?.selectDart3, setCriteriaList3);
    // }, [formDataAlert?.selectDart3]);

    /** | Replaced to this
     *  v Optimized variant
     */

    // useEffect(() => {
    //   if (!formDataAlert) return; // Guard clause for null or undefined formDataAlert.
    //   const { selectDart2, selectDart3, And_or } = formDataAlert;
    //   if (selectDart2 || selectDart3) {
    //     const selectedValue = (And_or === "&&") ? selectDart2 : selectDart3;
    //     fetchCriteriaList(selectedValue, setCriteriaList2);
    //   }
    // }, [formDataAlert.selectDart2, formDataAlert?.selectDart3]);
    // useEffect(() => { setSelectedRowIdInTable([]); }, []);

    useEffect(() => {
        if (overlayOpen) {
            setFormDataAlert({});
            setFormData({ name: '', description: '' });
            setRowID(null);
        }
    }, [overlayOpen]);

    useEffect(() => {
        console.log("Context in table: ", selectedRowIdInTable);
        (selectedRowIdInTable.length > 0) ? setDeleteDisabled(false) : setDeleteDisabled(true);

        const overlayIntoduction = (
            spinnerLoad ?
                <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
                    <Spinner />
                </Stack> :
                <form autoComplete="off" id="myForm" onSubmit={(e) => handleSubmit(e)}>
                    <Stack tokens={{ childrenGap: 10, padding: "10px 0px" }}>
                        <Stack horizontal> <Body1Strong> Name </Body1Strong><Image src="/Dashboard/image/required.svg" /> </Stack>
                        <StackItem> <Inputs inputChange={setFormData} inputVal={formData} required={true} /> </StackItem>
                        {/* {!classificationNameValidation && <Body1>This alert name already exists</Body1>} */}
                        <StackItem> <Body1Strong> What does this Alert Do? </Body1Strong> </StackItem>
                        <StackItem> <Resize inputChange={setFormData} inputValue={formData} /> </StackItem>
                        {empty}
                        <InfoBar title="These are the basic details associated with this Alert." />
                        <StackItem>
                            <Stack tokens={{ childrenGap: 10 }}>
                                <StackItem> <Body1Strong> What is the benefit? </Body1Strong> </StackItem>
                                <StackItem> <Body1 align='justify'> Alerts help the systems to send notfications whenever certain threshold value are crossed which helps to keep system in efficiant health condition. </Body1> </StackItem>
                            </Stack>
                        </StackItem>
                    </Stack>
                    <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}> Validate </Button>
                </form>
        );


        const overlayAlert = (
            <Stack>
                <Form // widgets={CustomWidgets} 
                    uiSchema={uiData}
                    id="alertForm"
                    ref={formRef}
                    formData={formDataAlert}
                    schema={jsonData}
                    validator={validator}
                    onChange={(e) => { setFormDataAlert(e.formData); /* fetchCriteriaList(formDataAlert?.selectDart2) */ }}
                />
            </Stack>
        );

        const overlayFixes = (
            <form autoComplete="off" id='myForm' onSubmit={(e) => handleSubmit(e)}>
                <Stack tokens={{ childrenGap: 10, padding: "10px 0px" }}>
                    <Caption1> <Body1Stronger> Suggested Fixes </Body1Stronger> </Caption1>
                    {/* <Dropdown placeholder="Select suggestions here">
            <div style={dropdownStyle}>
              {troubleshooterList && Array.isArray(troubleshooterList) ? troubleshooterList?.map((data: any) => <Option> {data?.automationName} </Option>) : null}
            </div>
          </Dropdown> */}
                    <MultiselectWithTags multi={true} tag={true} placeholder="Select suggestions here"
                        options={troubleshooterList} setSelectedOptions={setSelectedTroubleshooterList} selectedOptions={selectedTroubleshooterList} />
                </Stack>
                <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}> Validate </Button>
            </form>
        );

        const overlayReviewCreate = (
            <Stack tokens={{ childrenGap: 10, padding: "10px 0px" }}>
                <StackItem> <Body1Stronger> Name: </Body1Stronger> {formData.name} </StackItem>
                <StackItem> <Body1Stronger> Alert Description: </Body1Stronger> {formData.description} </StackItem>
                {/* Add more fields as necessary */}
                {empty}
                <Form // uiSchema={uiData} widgets={CustomWidgets}
                    ref={formRef} id="alertForm" uiSchema={uiData} formData={formDataAlert} schema={jsonData} validator={validator} disabled={true} />
                {empty}
                <StackItem>
                    <Body1Stronger> Selected Solutions: </Body1Stronger> {selectedTroubleshooterList?.map((val) => <StackItem> <Badge color="informative"> {val} </Badge> </StackItem>)}
                    {/* <MultiselectWithTags options={troubleshooterList} setSelectedOptions={setSelectedTroubleshooterList} selectedOptions={selectedTroubleshooterList} multi={true} tag={true} placeholder="Select suggestions here" disabled={true}/> */}
                </StackItem>
                {/* Add more fields as necessary */}
            </Stack>
        );

        setOverLayData({
            size: "large",
            isTabs: true,
            headerTitle: (overlayName == 'edit' ? <Title3> Edit Alert </Title3> : <Title3> Create Alert </Title3>),
            tabItems: { Introduction: overlayIntoduction, Configure: overlayAlert, Fixes: overlayFixes, "Review and Create": overlayReviewCreate }
        });
    }, [selectedRowIdInTable, overlayOpen, formDataAlert, formData, criteriaList2, criteriaList, criteriaList3, selectedTroubleshooterList]);

    // Add alert functionality.
    const addAlert = async (name: String, formDataEdit: any, variables: any, /*scope: any, group_include:any*/) => {
        var createdBy = userSessionDetails.userName;
        let createdOn = Math.floor(Date.now() / 1000);
        const status = "Not Attached";
        const { data } = await client.mutate({
            mutation: addAlertQuery,
            variables: { formDataEdit, variables, createdBy, createdOn, name, status }
        });
        const importedAlert = data.insert_event_Notifications_new.affected_rows;
        if (importedAlert > 0) { console.log('Imported alerts inserted successfully: ', importedAlert); };
    };

    // Check duplicates function
    function modifyAlertName(name: any, existingNames: Set<any>) {
        let modifiedName = name;
        let counter = 1;
        // If modifiedName already exists with the same type, append counter until unique
        while (existingNames.has(`${modifiedName}`)) {
            modifiedName = `${name}_${counter}`;
            counter++;
        };
        // Add the new unique name to the set
        existingNames.add(`${modifiedName}`);
        return modifiedName;
    };

    // Insert data into alerts DB
    const insertAlertData = async () => {
        if (csvAlertList.length > 0) {
            const newArray = csvAlertList[1];
            const [header, ...rows] = csvAlertList; // Extract header and rows

            console.log('CSV alert list: ', newArray);
            console.log('Checking newArray: ', typeof newArray);
            console.log('Header: ', header);

            const existingNames = new Set([ // Collect all existing names and their types from final_data and rows
                ...exportDetails.map(({ name }) => name), // using item.name as "name"
                ...rows.map((row) => row[1]) // Assuming name is at index 1 and types at index 2 in rows
            ]);

            // Loop through each row and call the mutate function
            const alertPromises = rows
                .filter(([name]) => name !== undefined) // Check if name and types are not undefined
                .map(([name, formDataEdit, variables /*, scope, group_include*/]) => addAlert(modifyAlertName(name, existingNames), formDataEdit, variables /*, scope, group_include*/));

            await Promise.all(alertPromises); // Wait for all addAlert promises to complete

            setImportedDataInserted(true); // Set data inserted flag to true after all insertions are complete
            setOverlayOpenNew(false);
            setCurrentPageNo(1);
            // setRefreshToast(true);
            setTimeout(() => setRefreshToast(false), 3000); // setTimeout(() => {}, 1000);
        }
    };

    // File export function with XLSX
    let exportToExcel = () => {
        const { writeFile, utils: { json_to_sheet, book_new, book_append_sheet } } = XLSX;
        // userActivity('Export', `{"summary":"Alert list exported"}`);
        const sheetData = json_to_sheet(exportData);
        const workbook = book_new();
        book_append_sheet(workbook, sheetData, "Sheet1"); // updatedWorkbook
        writeFile(workbook, `${tenantName}_alertAlerts.csv`); // exportedFile
    };

    // File upload handling function
    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        const selectedFile = event.target.files?.[0];

        console.log('Checking selectedFile: ', selectedFile?.name);

        setSelectedFile(selectedFile);
        if (!selectedFile) return;
        const reader = new FileReader();

        reader.onload = async (e: ProgressEvent<FileReader>) => {
            if (!e.target?.result) return;
            const data = new Uint8Array(e.target.result as ArrayBuffer);
            // Assuming you want to process the first sheet
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const jsonData: (string | number)[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            // Add current timestamp in epoch format and "Not Attached" to each item
            const updatedData = jsonData.map((item: (string | number)[]) => {
                // newItem.push(Math.floor(Date.now() / 1000)); // Current timestamp in epoch format
                // newItem.push("Not Attached"); // Static value
                return [...item]; // Assuming item is an array of numbers or strings
            });
            console.log('Imported Data: ', updatedData); // Process and display the updated data
            console.log('Imported Data type: ', typeof updatedData); // Process and display the updated data
            setCsvAlertList(updatedData);
        };
        reader.readAsArrayBuffer(selectedFile);
    };

    const empty = <StackItem> <Text /> </StackItem>;

    // import functiionality overlay JSX
    useEffect(() => {
        const overlayBody = () => (
            <Stack tokens={{ childrenGap: 10 }} horizontal>
                <StackItem grow shrink>
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem grow shrink>
                            <Stack tokens={{ childrenGap: 20 }} horizontalAlign="start">
                                <StackItem>
                                    <Stack tokens={{ childrenGap: 10 }}>
                                        {empty}
                                        <StackItem>
                                            <Body1> Start by exporting alerts list in all alerts page. </Body1>
                                            {/* <Body1> You can choose devices from the same site or different ones to create groups. </Body1> */}
                                        </StackItem>
                                        {empty}
                                        <StackItem> <Body1Strong> Steps to create the alerts </Body1Strong> </StackItem>
                                        <StackItem> <Body1> 1. Download the file that contains the list of alerts </Body1> </StackItem>
                                        <Stack>
                                            <StackItem> <Body1> 2. Check alerts in the CSV. </Body1> </StackItem>
                                            <StackItem>
                                                <Stack tokens={{ childrenGap: 15 }} horizontal>
                                                    {empty}
                                                    <StackItem>
                                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                            <StackItem> <Caption1> Watch the instructional video for guidance </Caption1> </StackItem>
                                                            <StackItem> <Open20Regular /> </StackItem>
                                                        </Stack>
                                                    </StackItem>
                                                </Stack>
                                            </StackItem>
                                        </Stack>
                                        <StackItem> <Body1> 3. Upload your .csv file </Body1> </StackItem>
                                        <StackItem>
                                            {/* <FileUploadComponent setDeviceList={setCsvAlertList} /> */}
                                            {/* <Button shape="circular" appearance='secondary' size='small' onClick={handleUpload}> Select a file </Button> */}
                                            <input type="file" onChange={handleFileChange} accept='.csv,.xlsx' id="fileUpload" /*style={{"display": "none"}} */ />
                                            {/* {selectedFile?.length > 0 && <Text> File selected: {selectedFile} </Text>} */}
                                            {/* <button onClick={ handleFileUpload}>Upload</button> */}
                                        </StackItem>
                                    </Stack>
                                </StackItem>
                            </Stack>
                        </StackItem>
                    </Stack>
                </StackItem>
            </Stack>
        );

        const overlayFooter = () => (
            <>
                <Button shape="circular" appearance="primary" onClick={insertAlertData}
                    disabled={(selectedFile?.length == 0 || csvAlertList?.length > 0) ? false : true}>
                    Submit
                </Button>
                {importedDataInserted && <Badge appearance="ghost" color="success"> <Body2> Alerts has been inserted successfully! </Body2> </Badge>}
            </>
        );

        setOverLayDataNew({
            size: "medium", isTabs: false, headerTitle: <Title3> {'Create Alerts'} </Title3>, bodyData: overlayBody(), footerData: overlayFooter()
        });
    }, [selectedFile, csvAlertList, importedDataInserted, overlayOpen]);

    useEffect(() => {
        var tableColumns: any[] = [];
        var filterColumns: any[] = [];

        contextAlerts.forEach((val) => {
            const { display, priority, key, name } = val;
            if (display.table.toLocaleLowerCase() === "yes" && priority >= 0) {
                if (key === "created_on_timezoned" || key === "last_modified_timezoned") {
                    tableColumns[priority] = ({
                        key: key,
                        label: (
                            <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                                <StackItem> <Body1Strong> {name} </Body1Strong> </StackItem>
                                <StackItem align="center">
                                    <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                                        <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                                    </Tooltip>
                                </StackItem>
                            </Stack>
                        )
                    });
                } else { tableColumns[priority] = ({ key: key, label: <Body1Strong> {name} </Body1Strong> }) };
            };
            if (display.filter.toLocaleLowerCase() === "yes") { filterColumns.push({ key: key, label: <Caption1> {name} </Caption1> }); };
        });
        setTableColumnsData(tableColumns);
        setFilterColumnsData(filterColumns);
        setManageViewDropDownData(contextAlerts.filter((val) => val.priority >= 0));
        setManageViewPageDetails({ module: "Automation", page: "Alerts" });
    }, [contextTable]);

    useEffect(() => {
        console.log("Checking selectedTroubleshooterList: ", selectedTroubleshooterList);
    }, [selectedTroubleshooterList]);

    useEffect(() => {
        if (final_data !== undefined && final_data !== null) {
            const newUniqueCreatedBy: string[] = [];
            final_data?.forEach((val: iCreatedBy) => {
                const { createdBy } = val;
                if (createdBy && createdBy.trim() !== "-" && !newUniqueCreatedBy.includes(createdBy)) { newUniqueCreatedBy.push(createdBy); }
            });
            setUniqueCreatedBy(newUniqueCreatedBy);
            console.log("Unique Created By: ", newUniqueCreatedBy);
        } else { setUniqueCreatedBy([]) }
    }, [final_data]);

    useEffect(() => {
        var menuLists: any = [];
        var tempTableData: any = [];
        console.log("Final data: ", final_data);

        // Data table values append code starts here
        final_data !== undefined && final_data !== null
            ? final_data?.map((val: iAlertTable) => {
                menuLists.push();

                const { name, id, status, createdBy, createdon, createdOn, lastModified } = val;
                console.log("Name***********: ", name);

                const hasPermit = (alertPermit: boolean) => {
                    const texts = (value: any) => <Caption1> {value ?? "-"} </Caption1>;
                    return ({
                        id: id,
                        checkbox: alertPermit && status !== 'Attached' ? 'show' : 'hide',
                        alert_name: {
                            label: alertPermit ? (
                                <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={() => handleOnCickEdit(val)}>
                                    {name}
                                </Button>
                            ) : (
                                <Tooltip withArrow content="You do not have access" relationship="description" positioning="above">
                                    <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small">{name}</Button>
                                </Tooltip>
                            ),
                        },
                        created_by: { label: texts(createdBy) },
                        created_on: { label: texts(convertUTCToReadableFormat(createdOn)) },
                        created_on_timezoned: { label: texts(convertToLocalTimezone(createdOn, userTimeZone)) },
                        last_modified: { label: texts(convertUTCToReadableFormat(lastModified)) },
                        last_modified_timezoned: { label: texts(convertToLocalTimezone(lastModified, userTimeZone)) },
                        status: { label: texts(status) },
                        // created_on: { label: texts(createdOn?.trim() ? convertUTCToReadableFormat(createdOn) : "-") },
                        // last_modified: { label: texts(lastModified?.trim() ? convertUTCToReadableFormat(lastModified) : "-") },
                    })
                };

                return tempTableData.push(alertPermit ? hasPermit(true) : hasPermit(false));
            }) : (tempTableData = []);

        tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
        setTimeout(() => {
            final_data !== undefined && final_data !== null && setLoading(false);
            if (isRefresh) {
                setIsRefresh(false);
                setRefreshToast(true);
                setTimeout(() => { setRefreshToast(false) }, 3000);
            }
        }, 500);
    }, [final_data, permissions, formData]);
    // Data table values append code ends here

    useEffect(() => {
        var tempExportData: any = [];
        var status = '';

        exportDetails?.length > 0 && exportDetails.map((val) => {
            if (val.status == 'not attached') { status = 'Not attached'; }
            else {
                var curStatus = val.status?.split("|").filter((val: string | any[]) => val.includes(tenantName));
                if (curStatus.length == 0) {
                    status = 'Not attached';
                } else {
                    curStatus = curStatus[0]?.split(":")[1];
                    const curSplit = curStatus?.split(",").length;
                    if (curStatus == 'all') { status = 'Enabled for All Devices'; }
                    else { status = curSplit == 1 ? `Enable for ${curSplit} Device Classification` : `Enable for ${curSplit} Device Classifications`; }
                };
            };

            // let jsonValue = JSON.stringify(val.varValues, null, 2).replace(/,/g, '\\,');
            tempExportData.push({
                'Name': val.name,
                'Created By': (val.createdBy != undefined && val.createdBy?.length > 0) ? val.createdBy : "-",
                'Created On': convertToExcelFormat(val.createdOn),
                'Last Modified': val.lastModified ? convertToExcelFormat(val.lastModified) : "-",
                'Status': status,
                // formDataEdit: val.formDataEdit, // variables: val.variables, // scope: val.scope, // group_include: val.group_include
            });
        });
        // setExportBtnClicked(false);
        setExportData(tempExportData);
    }, [exportDetails]);

    useEffect(() => {
        exportData.length > 0 && document.getElementById('csv-export-link')?.click();
    }, [exportData]);

    useEffect(() => {
        selectedRowIdInTable.length > 0 ? setDeleteDisabled(false) : setDeleteDisabled(true);
        selectedRowIdInTable.length > 0 ? setIsDuplicateDisabled(false) : setIsDuplicateDisabled(true);
    }, [selectedRowIdInTable]);


    const automationAlertData = () => (
        <Alert_func
            func={set_final_data}
            data={final_data}
            pageNo={(currentPageNo - 1) * 50}
            jsonData={jsonData}
            setJsonData={setJsonData}
            uiData={uiData}
            setUiData={setUiData}
            saveBtnClicked={saveBtnClicked}
            formDataAlert={formDataAlert}
            setSaveBtnClicked={setSaveBtnClicked}
            setEditBtnClicked={setEditBtnClicked}
            setFormDataAlert={setFormDataAlert}
            setToastAlertCreate={setToastAlertCreate}
            setToastAlertEdit={setToastAlertEdit}
            editBtnClicked={editBtnClicked}
            rowID={rowID}
            setRowID={setRowID}
            setOverlayName={setOverlayName}
            handleEditData={handleEditData}
            criteriaList={criteriaList}
            criteriaList2={criteriaList2}
            criteriaList3={criteriaList3}
            setToastAlertDelete={setToastAlertDelete}
            setIsDeleteAlert={setIsDeleteAlert}
            deleteAlert={deleteAlert}
            setTotalPages={setTotalPages}
            setTotalRecords={setTotalRecords}
            totalRecords={totalRecords}
            isRefresh={isRefresh}
            setIsRefresh={setIsRefresh}
            setExportDetails={setExportDetails}
            importedDataInserted={importedDataInserted}
            searchVal={searchVal}
            setSearchVal={setSearchVal}
            setToastAlertError={setToastAlertError}
            filterArray={filterArray}
            isfilter={isfilter}
            tenant={tenantName}
            setExportBtnClicked={setExportBtnClicked}
            exportBtnClicked={exportBtnClicked}
            formData={formData}
            setFormData={setFormData}
            setTroubleshooterList={setTroubleshooterList}
            selectedTroubleshooterList={selectedTroubleshooterList}
            overlayOpen={overlayOpen}
            setLoading={setLoading}
            setSpinnerLoad={setSpinnerLoad}
        />
    );

    const breadcrumbsData = () => (
        <StackItem grow shrink style={BreadcrumbsBorder}>
            <Stack tokens={{ childrenGap: 10 }} horizontal>
                <StackItem grow shrink>
                    <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                        {empty}
                        <StackItem grow shrink>
                            <Breadcrumbs items={[
                                { name: "Automate", link: "/home" },
                                { name: "Automation", link: "/automate/automation/all_automations" },
                                { name: "Alerts", link: "#" }
                            ]} />
                        </StackItem>
                    </Stack>
                </StackItem>
            </Stack>
        </StackItem>
    );

    const overflowData = () => {
        const handleAddAlert = () => {
            setFormDataAlert({});
            setOverlayName('');
            setSpinnerLoad(false);
            setSelectedTroubleshooterList([])
            // setCurrentPageNo(1);
            setOverlayOpen(true);
            // setCurrentPageNo(1);
            setFormData({})
        };

        const handleDelete = () => {
            setRowID();
            setIsDeleteAlert(true);
        };

        const handleRefresh = () => {
            setCurrentPageNo(1);
            setLoading(true);
            setRefreshToast(true);
            setIsRefresh(true);
        };

        const handleExport = () => {
            setExportBtnClicked(true);
        };

        const handleImport = () => {
            setOverlayOpenNew(true);
            // setSelectedValue(0);
            // setSelectedRowIdInSubTable([]);
            // setDevicesOfTenant(null);
            setCsvAlertList([]);
            // setClassificationName('');
            setImportedDataInserted(false);
        };

        const handleManageView = () => document.getElementById("manageView").click();

        const addAlertButton = () => (
            alertPermit
                ? (
                    <StackItem>
                        <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={handleAddAlert}>
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                <StackItem> <AddSquare20Regular {...(loading ? secondaryIcon : primaryIcon)} /> </StackItem>
                                <StackItem> <Caption1> Create Alert </Caption1> </StackItem>
                            </Stack>
                        </Button>
                    </StackItem>
                )
                : (
                    <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                        <Button shape="circular" appearance="subtle" size="small" disabled>
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                <StackItem>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
                                        <StackItem> <Caption1> Create Alert </Caption1> </StackItem>
                                    </Stack>
                                </StackItem>
                            </Stack>
                        </Button>
                    </Tooltip>
                )
        );

        const duplicateButton = () => (
            alertPermit
                ? (
                    <StackItem>
                        <DialogBox
                            headerButton={
                                <Button shape="circular" appearance="transparent" size="small"
                                    disabled={isDuplicateDisabled ? true : false} >
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> <Copy20Regular {...(isDuplicateDisabled ? secondaryIcon : primaryIcon)} /> </StackItem>
                                        <StackItem> <Caption1> Duplicate Alert </Caption1> </StackItem>
                                    </Stack>
                                </Button>
                            }
                            content="Kindly verify your intent to duplicate the alert."
                            footer={
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                    <StackItem>
                                        <Button shape="circular" appearance="primary" size="small" onClick={() => { setDuplicateAutomation(true) }}>
                                            Confirm
                                        </Button>
                                    </StackItem>
                                    <StackItem> <Button shape="circular" size="small"> Cancel </Button> </StackItem>
                                </Stack>
                            }
                        />
                    </StackItem>
                )
                : (
                    <StackItem>
                        <Tooltip withArrow content="You do not have access" relationship="description" positioning="above">
                            <Button shape="circular" appearance="subtle" size="small" disabled>
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    {empty}
                                    <StackItem>
                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                            <StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
                                            <StackItem> <Caption1> Duplicate Alert </Caption1> </StackItem>
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </Button>
                        </Tooltip>
                    </StackItem>
                )
        );

        const deleteButton = () => (
            <StackItem>
                <DialogBox
                    headerButton={
                        <Button shape="circular" appearance="transparent" size="small" onClickCapture={() => setCurrentPageNo(1)}
                            disabled={isdeletedisabled ? true : false}>
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                <StackItem> <Delete20Regular {...(isdeletedisabled ? secondaryIcon : primaryIcon)} /> </StackItem>
                                <StackItem> <Caption1> Delete </Caption1> </StackItem>
                            </Stack>
                        </Button>
                    }
                    content="Are you sure you want to delete this alert"
                    footer={
                        <Stack horizontal tokens={{ childrenGap: 10 }}>
                            <StackItem> <Button shape="circular" appearance="primary" onClick={handleDelete} size="small"> Confirm </Button> </StackItem>
                            <StackItem> <Button shape="circular" size="small"> Cancel </Button> </StackItem>
                        </Stack>
                    }
                />
            </StackItem>
        );

        const refreshButton = () => (
            <StackItem>
                <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={handleRefresh}>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem> <ArrowClockwise20Regular {...(loading ? secondaryIcon : primaryIcon)} /> </StackItem>
                        <StackItem> <Caption1> Refresh </Caption1> </StackItem>
                    </Stack>
                </Button>
            </StackItem>
        );

        const exportButton = () => (
            exportPermit
                ? (
                    <StackItem>
                        <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_automationAlerts.csv`} />
                        <Button shape="circular" appearance="subtle" size="small" disabled={loading || tableData.length === 0} onClick={handleExport}>
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                <StackItem> <ArrowDownload20Regular {...(loading || tableData.length === 0 ? secondaryIcon : primaryIcon)} /> </StackItem>
                                <StackItem> <Caption1> Export </Caption1> </StackItem>
                            </Stack>
                        </Button>
                    </StackItem>
                )
                : (
                    <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                        <Button shape="circular" appearance="subtle" size="small" disabled>
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                <StackItem>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                                        <StackItem> <Caption1> Export </Caption1> </StackItem>
                                    </Stack>
                                </StackItem>
                            </Stack>
                        </Button>
                    </Tooltip>
                )
        );

        const importButton = () => (
            importPermit
                ? (
                    <StackItem>
                        {/* <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_automationAlerts.csv`}> */}
                        <Button shape="circular" appearance="subtle" size="small" disabled={loading || tableData.length === 0} onClick={handleImport}>
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                <StackItem> <ArrowUpload20Regular {...(loading || tableData.length === 0 ? secondaryIcon : primaryIcon)} /> </StackItem>
                                <StackItem> <Caption1> Import </Caption1> </StackItem>
                            </Stack>
                        </Button>
                        {/* </CSVLink> */}
                    </StackItem>
                )
                : (
                    <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                        <Button shape="circular" appearance="subtle" size="small" disabled>
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                <StackItem>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> <ArrowUpload20Regular {...secondaryIcon} /> </StackItem>
                                        <StackItem> <Caption1> Import </Caption1> </StackItem>
                                    </Stack>
                                </StackItem>
                            </Stack>
                        </Button>
                    </Tooltip>
                )
        );

        const manageViewButton = () => (
            <StackItem>
                <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={handleManageView}>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem> <Settings20Regular {...(loading || tableData.length === 0 ? secondaryIcon : primaryIcon)} /> </StackItem>
                        <StackItem> <Caption1> Manage View </Caption1> </StackItem>
                    </Stack>
                </Button>
            </StackItem>
        );

        const fullScreenButton = () => (
            <StackItem grow shrink>
                <Stack horizontalAlign="end"> <StackItem grow shrink> <FullScreenButton handle={handle} /> </StackItem> </Stack>
            </StackItem>
        )

        const overFlowContent = {
            data: (
                <>
                    {addAlertButton()}
                    <StackItem> <Divider vertical /> </StackItem>
                    {duplicateButton()}
                    <StackItem> <Divider vertical /> </StackItem>
                    {deleteButton()}
                    <StackItem> <Divider vertical /> </StackItem>
                    {refreshButton()}
                    {exportButton()}
                    {importButton()}
                    {manageViewButton()}
                    {fullScreenButton()}
                </>
            )
        };

        return (
            <StackItem>
                <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowContent} />
                <Divider />
            </StackItem>
        );
    };

    const pageControls = () => {
        const handleFilter = () => setFilterMenuOpen(true);

        const handleReset = () => {
            setFilterArray([]);
            setIsFilter(false);
            setDropDownValue2('');
            setResetDisabled(true);
        };

        const handleApply = () => {
            handleFilterArray();
            setFilterMenuOpen(false);
        };

        const handleCancel = () => {
            setFilterMenuOpen(false);
            setDropDownValue1('');
            setDropDownValue2('');
        };

        const applyDisabled = !dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`));

        const searchBarData = () => (
            <StackItem>
                <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
            </StackItem>
        );

        const filtersData = () => {
            const filterButton = () => (
                <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={handleFilter}>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <Filter20Filled {...(loading || tableData.length === 0 ? secondaryIcon : primaryIcon)} />
                        <Body1> Filter </Body1>
                    </Stack>
                </MenuButton>
            );

            const filterContent = () => {
                const filterOptions = () => (
                    <>
                        <StackItem> <Caption1> Filter </Caption1> </StackItem>
                        <DropdownComponent
                            optionData={filterColumnsData}
                            dropDownvalue={dropDownValue1}
                            setDropDownValue={(newValue: any) => {
                                setDropDownValue1(newValue);
                                setDropDownValue2('');
                            }}
                        />
                    </>
                );

                const valueOptions = () => (
                    <>
                        <StackItem> <Caption1> Value </Caption1> </StackItem>
                        {
                            ((dropDownValue1 === 'Created On' || dropDownValue1 === 'Last Modified')) &&
                            <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />
                        }
                        {
                            ((dropDownValue1 === "Name") || (dropDownValue1 === "Status")) &&
                            <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />
                        }
                        {
                            dropDownValue1 === "Created By" &&
                            (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`))
                                ? <span style={{ color: 'red' }}> This column is already filtered. </span>
                                : <DropdownComponent optionData={isCreatedBy} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />)
                        }
                    </>
                );

                const actionButtons = () => (
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem>
                            <Button shape="circular" onClick={handleApply} appearance="primary" disabled={applyDisabled}>
                                <Caption1> Apply </Caption1>
                            </Button>
                        </StackItem>
                        <StackItem>
                            <Button shape="circular" onClick={handleCancel}>
                                <Caption1> Cancel </Caption1>
                            </Button>
                        </StackItem>
                    </Stack>
                );

                return (
                    <>
                        <Body1Strong> Add a Filter </Body1Strong>
                        <Divider />
                        <MenuList>
                            <Stack tokens={{ childrenGap: 5 }}>
                                {empty}
                                {filterOptions()}
                                <StackItem> <Divider /> </StackItem>
                                {valueOptions()}
                                <StackItem> <Divider /> </StackItem>
                                {actionButtons()}
                            </Stack>
                        </MenuList>
                    </>
                );
            };

            return <StackItem> <MenuDropdown open={filterMenuOpen} btn={filterButton()} itemVal={filterContent()} /> </StackItem>;
        };

        const resetData = () => (
            <StackItem onClick={handleReset}>
                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem> <FilterDismiss20Filled {...(isResetDisabled ? secondaryIcon : primaryIcon)} /> </StackItem>
                        <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                    </Stack>
                </Button>
            </StackItem>
        );

        const paginationData = () => (tableData.length > 0 && !loading) && (
            <StackItem>
                <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} />
            </StackItem>
        );

        const discardData = () => (
            <StackItem>
                {filterArray.length > 0 && (
                    <Stack horizontal wrap>
                        {filterArray.map((item, index) => (
                            <Button shape="circular" size="small">
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                    <StackItem>
                                        <Stack tokens={{ childrenGap: 1 }}>
                                            {empty}
                                            <StackItem> <Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /> </StackItem>
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </Button>
                        ))}
                    </Stack>
                )}
            </StackItem>
        );

        const countData = () => (
            <StackItem disableShrink>
                {(tableData.length > 0 && !loading && totalRecords > 0) && (
                    <Caption1>
                        Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                    </Caption1>
                )}
            </StackItem>
        );

        return (
            <StackItem style={wraperStyle}>
                <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                        {searchBarData()}
                        {filtersData()}
                        {resetData()}
                    </Stack>
                    {paginationData()}
                </Stack>
                <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                    {discardData()}
                    {countData()}
                </Stack>
            </StackItem>
        );
    };

    const alertTableData = () => (
        loading
            ? <SkeletonDataTable />
            : (tableData.length > 0)
                ? <DataTable tableData={tableData} columns={tableColumnsData} setOverlayOpen={setOverlayOpen} />
                : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}>
                    <StackItem> <Text size={500}> No result. </Text> </StackItem>
                </Stack>
    );

    const overlaysData = () => (
        <>
            <OverLay handleOutsideButton={handleOutsideButton} handleSubmit={handleSubmit} overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData={overLayData} isNavBtn={true} saveBtnFunc={handleSave} saveBtnClicked={saveBtnClicked} formRef={formRef} />
            <OverLay handleOutsideButton={handleOutsideButton} handleSubmit={handleSubmit} overlayopen={overlayOpenNew} setOverlayOpen={setOverlayOpenNew} overlayData={overLayDataNew} formRef={formRef} />
        </>
    );

    const toastData = () => {
        const renderToast = (isVisible: boolean, intent: string, title: string, message: string) => !isVisible ? null
            : <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent={intent} position="top-end" title={title} message={message} footer="" />;
        return (
            <>
                {renderToast(toastAlertCreate, "success", "Success", "Alert Created Successfully!")}
                {renderToast(refreshToast, "success", "Success", "Data Table Refreshed")}
                {renderToast(toastAlertEdit, "success", "Success", "Alert  data Updated Successfully")}
                {renderToast(toastAlertError, "failed", "Failed", "Sorry some Error")}
                {renderToast(toastAlertDelete, "success", "Success", "Alert Deleted Successfully")}
            </>
        );
    };

    return (
        <FullScreen handle={handle} className="fullScreenBackgroundColor">
            {breadcrumbsData()}
            {automationAlertData()}
            {/* {tracker && <Activity_log_func data={userActivityData} setTracker={setTracker} type="insertLog" />} */}
            <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
                <StackItem style={DynamicBoxingCSS}>
                    <Stack style={DynamicBoxingCSS}>
                        <FluentProvider style={parentHome} theme={dashboardTheme}>
                            <Stack style={parentHome} horizontal>
                                <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={AutomationPages("Alerts")} />
                                <StackItem style={DynamicBoxingCSS}>
                                    <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                                        {overflowData()}
                                        <StackItem style={wraperStyle}>
                                            {pageControls()}
                                            <InfoBar showSpaces={true} title={"Alerts is the section where notifications are configured and managed to monitor specific events or conditions, ensuring timely responses to potential issues."} />
                                        </StackItem>
                                        {alertTableData()}
                                    </Stack>
                                </StackItem>
                            </Stack>
                        </FluentProvider>
                    </Stack>
                    {overlaysData()}
                    {toastData()}
                </StackItem>
                {empty}
            </Stack>
        </FullScreen>
    );
};
